import RepresentativeSimpleForm from './RepresentativeSimpleForm'

export default RepresentativeSimpleForm
